import { _ } from "~/route/globals";

export const TYPE_ID = {
	1: "bus",
	2: "tram",
	3: "cableWay",
	4: "metro",
	5: "ferryBoat",
	6: "trolley",
	7: "train",
};

export const SECTION_ITEM_TYPE = {
	drive: 0,
	walk: 1,
	wait: 2,
};

export const PLATFORM_INFO = {
	24: {
		icon: "barrierFree",
		tooltip: () => _("route4.pubt.detail.list.icon.platform_info.1"),
	},
	28: {
		icon: "onRequest",
		tooltip: () => _("route4.pubt.detail.list.icon.platform_info.2"),
	},
	37: {
		icon: "outputOnly",
		tooltip: () => _("route4.pubt.detail.list.icon.platform_info.3"),
	},
	38: {
		icon: "justBoarding",
		tooltip: () => _("route4.pubt.detail.list.icon.platform_info.4"),
	},
	44: {
		icon: "forOrder",
		tooltip: () => _("route4.pubt.detail.list.icon.platform_info.5"),
	},
};

export const LINE_INFO = {
	45: {
		icon: "wifi",
		tooltip: () => _("route4.pubt.detail.list.icon.line_info.1"),
	},
	15: {
		icon: "barrierFree",
		tooltip: () => _("route4.pubt.detail.list.icon.line_info.2"),
	},
	20: {
		icon: "bicycle",
		tooltip: () => _("route4.pubt.detail.list.icon.line_info.3"),
	},
	46: {
		icon: "airConditioning",
		tooltip: () => _("route4.pubt.detail.list.icon.line_info.4"),
	},
};
